// Controls the "Разрешить уведомления?" prompt (notifications.js
// _showNotificationPrompt). requestShow() only opens it when the browser
// permission is still 'default' — matching the original gate.
import { create } from 'zustand'

interface NotifyPromptState {
  open: boolean
  requestShow: () => void
  dismissNative: (userId: string | null) => void
  clearNativeDismissal: (userId: string | null) => void
  isNativeDismissed: (userId: string | null) => boolean
  close: () => void
}

const nativeDismissKey = (userId: string) => `humanteq-native-push-prompt-dismissed:${userId}`

export const useNotifyPromptStore = create<NotifyPromptState>()((set) => ({
  open: false,
  requestShow: () => {
    const supported = typeof window !== 'undefined' && 'Notification' in window
    if (supported && Notification.permission === 'default') {
      set({ open: true })
    }
  },
  dismissNative: (userId) => {
    if (!userId) return
    localStorage.setItem(nativeDismissKey(userId), '1')
    set({ open: false })
  },
  clearNativeDismissal: (userId) => {
    if (userId) localStorage.removeItem(nativeDismissKey(userId))
  },
  isNativeDismissed: (userId) =>
    Boolean(userId && localStorage.getItem(nativeDismissKey(userId)) === '1'),
  close: () => set({ open: false }),
}))
